import React from 'react';

import Head from 'next/head';

import featureNames from '~/shared/constants/featureFlags';
import useHasFeature from '~/shared/utils/useHasFeature';

const LoginRecaptcha = () => {
  const { enabled: isTurnstileEnabled } = useHasFeature(featureNames.TURNSTILE);
  if (isTurnstileEnabled) {
    return (
      <>
        <Head>
          <script
            src="https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
            async
            defer
          >
            &nbsp;
          </script>
          <link rel="preconnect" href="https://challenges.cloudflare.com" />
        </Head>
      </>
    );
  } else {
    return null;
  }
};

export default LoginRecaptcha;
